export const ru = {
    add_participant: 'Добавление участника',
    cancel: 'Отменить',
    save: 'Сохранить',
};
